import { Menu, Transition } from '@headlessui/react';
import { ChevronDownIcon } from '@heroicons/react/20/solid';
import { LoaderFunctionArgs } from 'react-router';
import { Link, NavLink, Outlet, useLoaderData } from 'react-router';
import { Fragment } from 'react';
import { setDbFromContext } from '~/lib/db';
import { getPairByBaseToken } from '~/lib/models/pair';
import { getTokenStakingByToken } from '~/lib/models/staking';
import { getToken } from '~/lib/models/tokens';
import { getIconUrl, onIconError } from '~/lib/util';
import { loader as pairsLoader } from '~/routes/cronjob.new-pairs';


export async function loader({ params, context }: LoaderFunctionArgs) {
   setDbFromContext(context);

   // always check for new pairs first
   // await pairsLoader({ context });

   if (!params?.address) {
      return ({
         error: 'Missing token',
         token: null,
         staking: null,
      });
   }

   const [token] = await getToken(params.address);
   const [staking] = await getTokenStakingByToken(params.address);

   console.log(token);

   return ({
      error: null,
      token,
      staking,
   });
}

export default function Token() {
   const { token, staking } = useLoaderData<typeof loader>();

   return (
     <>
       <div className="spacy-y-4 mx-4 mb-8 xl:mx-auto xl:w-3/5">
         <div className="flex items-center justify-between">
           <h1 className="flex items-center text-left text-4xl font-bold">
             <img className="mr-3 h-12 w-12 shrink-0 rounded-full bg-white" src={getIconUrl(token.iconUrl, 32)} onError={(evt) => onIconError(evt)} alt="" />
             {token.name}
             <span className="text-primary-800 dark:text-primary-100 ml-3">{token.symbol}</span>
           </h1>
           {/* <Link
                  to="/liquidity/add"
                  className="leading-none uppercase tracking-wider text-md font-medium rounded-full py-3 px-4 text-white hover:bg-primary-500 border border-white hover:border-primary-500"
               >
                  Add Liquidity
               </Link> */}
         </div>

         <div className="mt-4 flex items-center justify-between">
           <div className="flex space-x-4">
             <NavLink
               to={`/token/${token.address}`}
               className={({ isActive }) =>
                 (isActive ? "border-black dark:border-white" : "border-transparent") + " mx-4 block w-full border-b-2 pt-0.5 hover:border-black lg:w-min dark:hover:border-white"
               }
               end
             >
               Info
             </NavLink>
             <NavLink
               to={`/token/${token.address}/pools`}
               className={({ isActive }) =>
                 (isActive ? "border-black dark:border-white" : "border-transparent") + " mx-4 block w-full border-b-2 pt-0.5 hover:border-black lg:w-min dark:hover:border-white"
               }
             >
               Pools
             </NavLink>
             {staking ? (
               <NavLink
                 to={`/token/${token.address}/staking`}
                 className={({ isActive }) =>
                   (isActive ? "border-black dark:border-white" : "border-transparent") + " mx-4 block w-full border-b-2 pt-0.5 hover:border-black lg:w-min dark:hover:border-white"
                 }
               >
                 Staking
               </NavLink>
             ) : null}
           </div>

           <Menu as="div" className="relative inline-block text-left">
             <div>
               <Menu.Button className="bg-primary-100 focus:outline-hidden inline-flex w-full justify-center rounded-md px-4 py-2 text-sm font-medium text-black hover:bg-black/30 focus-visible:ring-2 focus-visible:ring-white/75 dark:bg-black/20 dark:text-white">
                 Owner tools
                 <ChevronDownIcon className="dark:text-primary-100 -mr-1 ml-2 h-5 w-5 text-black hover:text-violet-100" aria-hidden="true" />
               </Menu.Button>
             </div>
             <Transition
               as={Fragment}
               enter="transition ease-out duration-100"
               enterFrom="transform opacity-0 scale-95"
               enterTo="transform opacity-100 scale-100"
               leave="transition ease-in duration-75"
               leaveFrom="transform opacity-100 scale-100"
               leaveTo="transform opacity-0 scale-95"
             >
               <Menu.Items className="focus:outline-hidden absolute right-0 mt-2 w-56 origin-top-right divide-y divide-gray-100 rounded-md bg-white shadow-lg ring-1 ring-black/5">
                 <div className="px-1 py-1">
                   <Menu.Item>
                     {({ active }) => (
                       <Link
                         to={`/token/${token.address}/admin/edit`}
                         className={`${active ? "bg-violet-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                       >
                         Edit {token.symbol}
                       </Link>
                     )}
                   </Menu.Item>
                   <Menu.Item>
                     {({ active }) => (
                       <Link
                         to={`/token/${token.address}/admin/burn`}
                         className={`${active ? "bg-violet-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                       >
                         Burn {token.symbol}
                       </Link>
                     )}
                   </Menu.Item>
                 </div>
                 <div className="px-1 py-1">
                   {!staking ? (
                     <Menu.Item>
                       {({ active }) => (
                         <Link
                           to={`/token/${token.address}/admin/staking`}
                           className={`${active ? "bg-violet-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                         >
                           Staking
                         </Link>
                       )}
                     </Menu.Item>
                   ) : (
                     <>
                       <Menu.Item>
                         {({ active }) => (
                           <Link
                             to={`/token/${token.address}/admin/staking-deposit`}
                             className={`${active ? "bg-violet-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                           >
                             Staking deposit
                           </Link>
                         )}
                       </Menu.Item>
                       <Menu.Item>
                         {({ active }) => (
                           <Link
                             to={`/token/${token.address}/admin/staking-widget`}
                             className={`${active ? "bg-violet-500 text-white" : "text-gray-900"} group flex w-full items-center rounded-md px-2 py-2 text-sm`}
                           >
                             Staking widget
                           </Link>
                         )}
                       </Menu.Item>
                     </>
                   )}
                 </div>
               </Menu.Items>
             </Transition>
           </Menu>
         </div>

         <div className="mt-8 flex flex-col space-y-4">
           <Outlet />
         </div>
       </div>
     </>
   );
}
